import { ROUTES_NAMES } from '@/constants';
import ForgotPasswordConfirm from '@/views/ForgotPasswordConfirm.vue';
import { beforeEnterConfirmForgotPasswordRoute } from './forgotPasswordConfirmNavigationGuards';

const confirmRegistrationRoute = {
  path: '/forgotpassword/confirm',
  name: ROUTES_NAMES.forgotPasswordConfirm,
  component: ForgotPasswordConfirm,
  beforeEnter: beforeEnterConfirmForgotPasswordRoute
};

export default confirmRegistrationRoute;
